import classNames from "classnames";
import StyledCheckbox from "../../../common/inputs/StyledCheckbox";
import styles from "./LabeledCheckbox.module.css";

type Props = {
  label: string;
  checkboxLabel: string;
  checked: boolean;
  onCheck: (checked: boolean) => void;
  isExpired?: boolean;
  disabled?: boolean;
  className?: string;
};

export default function LabeledCheckbox({
  label,
  checkboxLabel,
  checked,
  onCheck,
  isExpired,
  disabled,
  className,
}: Props) {
  return (
    <div className={className}>
      <div className={styles.label}>{label}</div>
      <StyledCheckbox
        className={classNames({
          [styles.checkbox]: true,
          [styles.expired]: isExpired,
        })}
        checked={checked}
        onChange={(e) => onCheck(e.currentTarget.checked)}
        label={checkboxLabel}
        disabled={disabled}
      />
    </div>
  );
}
